module.exports = __webpack_public_path__ + "static/img/KH.7004964d.png";